import React, { useEffect, useState } from "react";
import "../dashboard.scss";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import { deletehostelvistor, listhostelvistor } from "../../../services/admin";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
export default function Allhostelvisitors() {
  const navigate = useNavigate();
  const [filterProduct, setFilterProduct] = useState([]);

  const columnDefs = [
    {
      headerName: "Actions",
      width: 100,
      field: "id",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => navigate(`/hostel/hostelvisitorsdetail/${params.value}`)}
              className="btn-sm btn-info me-2"
            >
              <i className="fa fa-edit"></i>
            </a>
            <a className="btn-sm btn-danger" onClick={() => handleSwitch(params.value)}>
              <i className="fa fa-trash"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Visitor Name",
      width: 170,
      field: "visitor_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Visitor Date",
      width: 150,
      field: "visitor_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          moment(params.value).format("DD-MM-YYYY")
        );
      }
    },
    {
      headerName: "Category",
      width: 170,
      field: "category",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Meeting With",
      width: 170,
      field: "meeting_with",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Phone Number",
      width: 170,
      field: "visitor_phone",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "In Time",
      width: 170,
      field: "visitor_intime",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Out Time",
      width: 170,
      field: "visitor_outtime",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Academy",
      width: 120,
      field: "academy_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },


  ];

  useEffect(() => {
    funlist();
    
  }, []);

  function funlist() {
    setFilterProduct([]);
    listhostelvistor().then((res) => {
      if (res.status === true) {
        setFilterProduct(res.data);
      }
    });
    
  }

  function handleSwitch(list) {
    Swal.fire({
      text: "Are you sure want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        const temp = new FormData();
        temp.append("id", list);

        deletehostelvistor(temp).then((response) => {
          if (response.status === true) {
            funlist();
          }
        });
      }
    });
  }

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">All Hostel Visitors</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a>Hostel Management</a></li>
          <li className="breadcrumb-item active" aria-current="page">All Hostel Visitors</li>
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body">
                  <div className="ag-theme-alpine ag-style">
                    <AgGridReact
                      columnDefs={columnDefs}
                      rowData={filterProduct}
                      pagination="true"
                      paginationPageSize="10"
                      sortingOrder={["asc", "desc"]}
                      suppressDragLeaveHidesColumns={true}
                    />
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
